module.exports = __webpack_public_path__ + "files/1f68822390384a2e5a278c95811456cf.png";